import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e331a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onContextmenu"]
const _hoisted_2 = {
  key: 0,
  class: "q-ml-xs"
}

import ContextMenu from '@/components/facility/MenuAbstract.vue';
import ModalActions from '@/components/facility/ModalAbstract.vue';
import { storeToRefs } from 'pinia';
import {
  toRefs, onUnmounted, ref,
} from 'vue';
import { useDivisionStore } from '~store/division/divisionModule';
import { Facility } from './types';

interface Props {
  data?: Facility[],
  deep?: number[],
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FacilityAbstract',
  props: {
    data: null,
    deep: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { data?: Facility[], deep: number[] }


const divisionStore = useDivisionStore();
const { facilityNodesState, facilityMock } = storeToRefs(divisionStore);

const { data, deep } = toRefs(props);

const isHovered = ref(false);
const pointID = ref<number | null>(null);

const showModal = ref(false);
const removeNode = ref(false);
const addNode = ref(false);

const nodeName = ref<string | undefined>(undefined);
const parentNodeName = ref<string | undefined>(undefined);

const additionalValue = ref<string | undefined>(undefined);
const newName = ref<string | undefined>(undefined);
const alias = ref<string | undefined>(undefined);
const additional = ref<string | undefined>(undefined);

// Определяем порядок заглубления
const getNodeOrder = (key: string): number => {
  switch (key) {
    case 'subjectRF': return 1;
    case 'district': return 2;
    case 'address': return 3;
    case 'building': return 4;
    case 'number_space': return 5;
    case 'point': return 6;
    default: return 0;
  }
};

// Сравниваем порядок текущего узла с выбранными, если есть более глубокие выбранные - стираем
const collapseChildren = (item: Facility): void => {
  Object.values(facilityNodesState.value).forEach((node) => {
    if (node) {
      if (getNodeOrder(node.field_name) > getNodeOrder(item.field)) {
        facilityNodesState.value[node.field_name] = null;
      }
    }
  });
};

// Проверяем, если выбран адрес, строение или помещение, ищем блоки
const checkPoints = (): void => {
  if (
    facilityNodesState.value.address
    || facilityNodesState.value.building
    || facilityNodesState.value.number_space
  ) {
    divisionStore.getPoints({
      id_address: facilityNodesState.value.address?.id ?? 0,
      id_building: facilityNodesState.value.building?.id ?? 0,
      id_space: facilityNodesState.value.number_space?.id ?? 0,
    });
  }
};

// Углубляемся по индексам из deep, возвращая следующий уровень вложенности
const findPath = (path: any, index: number): Facility[] => path[index][path[index].child_field];

const selectNode = (item: Facility) => {
  // Выбираем и устанавливаем узел по названию поля
  facilityNodesState.value[item.field] = {
    field_name: item.field,
    name: item[item.field],
    id: item[item.field_id],
    tooltip: item.field_alias,
  };
  if (
  // Если заглубились
    deep.value.length
    && (
      // НЕ выбран или уже забыт родительский узел
      !facilityNodesState.value[item.field_parent]
      || ( // ИЛИ id родителя выбранного узла не совпадает с field_parent_id текущего экземпляра
        facilityNodesState.value[item.field_parent]?.id
        !== facilityMock.value?.[deep.value[deep.value.length - 1]][item.field_parent_id]
      )
    )
  ) {
    // Началом пути для прохода выбираем корень
    let path = facilityMock.value;
    // Проходим по массиву углубления, стакая путь до текущего уровня
    // на каждой итерации выбираем и запоминаем узлы
    deep.value.forEach((i) => {
      facilityNodesState.value[path?.[i].field ?? ''] = {
        field_name: path?.[i].field ?? '',
        name: path?.[i][path[i].field],
        id: path?.[i][path[i].field_id],
        tooltip: path?.[i].field_alias ?? '',
      };
      // и получаем путь до следующего уровня вложенности
      path = findPath(path, i);
    });
  }
  collapseChildren(item); // Проверяем выбранные узлы
  checkPoints(); // Обновляем список поинтов
};

const relevantIcon = (key: string): string => {
  switch (true) {
    case key.includes('subjectRF'): return 'location_city';
    case key.includes('district'): return 'near_me';
    case key.includes('address'): return 'location_on';
    case key.includes('building'): return 'home';
    case key.includes('space'): return 'space_dashboard';
    case key.includes('point'): return 'radio_button_checked';
    default: return '';
  }
};

// Выстраиваем каждому узлу путь от корня по индексам
const defineDeep = (index: number): number[] => [...deep.value, index];

const isSelected = (
  item: Facility,
): boolean => item[item.field_id] === facilityNodesState.value[item.field]?.id;

const onDrop = (e: any) => {
  pointID.value = +e.dataTransfer.getData('itemID');
  console.log(pointID.value);
  // setFloorModal.value = true;
};

const openPopup = (node: Facility, action: string): void => {
  console.log(node, action);
  switch (action) {
    case 'confirmRemove':
      nodeName.value = node.field;
      newName.value = node[node.field];
      removeNode.value = true;
      break;
    case 'add':
      addNode.value = true;
      alias.value = node.field_child_alias;
      parentNodeName.value = node[node.field];
      switch (node.child_field) {
        case 'buildings': additional.value = 'Индекс'; break;
        case 'spaces': additional.value = 'Этажность'; break;
        case 'points': additional.value = 'Этаж'; break;
        default: return;
      }
      break;
    default: return;
  }
  showModal.value = true;
};

const closePopup = (): void => {
  showModal.value = false;
  removeNode.value = false;
  addNode.value = false;
  nodeName.value = undefined;
  alias.value = undefined;
  parentNodeName.value = undefined;
  additional.value = undefined;
  additionalValue.value = undefined;
  newName.value = undefined;
};

const initRemove = (name: string) => {
  console.log(name);
};

const initAddNode = (name: string) => {
  console.log(name);
};

onUnmounted(() => {
  // На закрытии узла, сворачиваем всех потомков
  data?.value?.forEach((i) => {
    const item = i;
    item.child = 1;
  });
});


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_facility_abstract = _resolveComponent("facility-abstract", true)!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_q_list, { separator: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
          return (_openBlock(), _createBlock(_component_q_item, {
            class: "column q-pb-none q-pl-sm",
            key: item[item.field_id]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["q-mb-none", {
            hoveredWrapper: isHovered.value && item.field === 'number_space',
            noChildrenOffset: !item.child_n
          }]),
                onDrop: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onDrop($event), isHovered.value = false), ["prevent","stop"])),
                onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isHovered.value = true), ["prevent"])),
                onDragleave: _cache[2] || (_cache[2] = ($event: any) => (isHovered.value = false, pointID.value = null))
              }, [
                (item.child_n ?? 0 > 0)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      size: "xs",
                      icon: item.child ? "add" : "remove",
                      type: "reset",
                      color: "white",
                      "text-color": "standard",
                      class: "q-mx-sm q-mb-sm",
                      onClick: _withModifiers(($event: any) => {item.child === 1 ? item.child = 0 : item.child = 1; selectNode(item);}, ["stop"])
                    }, null, 8, ["icon", "onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass(["node-wrapper", {
              hovered: isHovered.value && item.field === 'number_space',
            }])
                }, [
                  _createVNode(_component_q_icon, {
                    name: relevantIcon(item.field),
                    size: "16px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.field_alias), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["name"]),
                  (item.child_n)
                    ? (_openBlock(), _createBlock(_component_q_badge, {
                        key: 0,
                        color: "dark",
                        class: "inline-block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: relevantIcon(item.child_field),
                            size: "14px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.field_child_alias), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createTextVNode(" " + _toDisplayString(item.child_n), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["q-ml-xs", {
                selected: isSelected(item),
              }]),
                    onClick: _withModifiers(($event: any) => (selectNode(item)), ["stop"]),
                    onContextmenu: _withModifiers(($event: any) => (selectNode(item)), ["prevent"])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item[item.field]), 1),
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      (item.zip || item.n_floors)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _createVNode(_component_q_badge, {
                              color: "black",
                              rounded: "",
                              label: item.zip || item.n_floors
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (item.has_event === 1)
                      ? (_openBlock(), _createBlock(ContextMenu, {
                          key: 0,
                          node: item,
                          onShowModal: openPopup
                        }, null, 8, ["node"]))
                      : _createCommentVNode("", true)
                  ], 42, _hoisted_1),
                  _createElementVNode("span", null, [
                    (item.has_event === 1)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "more_vert",
                          size: "14px"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (item.child === 0)
                  ? (_openBlock(), _createBlock(_component_facility_abstract, {
                      key: 1,
                      is: item.child_field,
                      data: item[item.child_field],
                      deep: defineDeep(index)
                    }, null, 8, ["is", "data", "deep"]))
                  : _createCommentVNode("", true)
              ], 34)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }),
    (showModal.value)
      ? (_openBlock(), _createBlock(ModalActions, {
          key: 0,
          nodeName: nodeName.value,
          confirm: removeNode.value,
          add: addNode.value,
          parentName: parentNodeName.value,
          additional: additionalValue.value,
          name: newName.value,
          nodeAlias: alias.value,
          nodeAdditional: additional.value,
          onCancel: closePopup,
          onRemoveNode: initRemove,
          onCreateNode: initAddNode
        }, null, 8, ["nodeName", "confirm", "add", "parentName", "additional", "name", "nodeAlias", "nodeAdditional"]))
      : _createCommentVNode("", true)
  ]))
}
}

})